import styled from '../theme'
import GeoSuggest from 'react-geosuggest'

interface ICentreProps {
  addPadding?: boolean;
}

interface IConditionalMessageProps {
  addMargin?: boolean;
}

export const Body = styled.p`
    font-size: 16px;
    font-family: tourismbody;
    text-align: left;
    color: ${(props: any) => JSON.parse(props.theme.colors).backgroundDark2};
    margin: 0 auto;
    margin-top: 11px;
    max-width: 653px;
    margin-top: 5px;
    width: 80%;
    letter-spacing: 0.5px;
    overflow: auto;

    @media (max-width: 768px) {
      margin: 1em 0;
      padding-left: 6px;
      width: 98%;
      text-align: left;
    }
`

export const Disclaimer = styled.p`
    font-size: 1em;
    font-family: tourismbody;
    overflow: auto;

    @media (min-width: 768px) {
      margin-left: -1px;
    }

    @media (max-width: 550px) {
        width: 100%;
        margin: 1em 0 1em 1em;
    }
`
export const CentreLogo = styled<ICentreProps, 'img'>('img')`
  @media (max-width: 768px) {
    margin-top: 5px;
    max-width: 100%;
    height: auto;
  }
`

export const NextButton = styled.button`
    width: 22%;
    height: 42px;
    margin-top: 17px;
    padding-bottom: 0px;
    font-weight: 400px;
    text-align: center;
    border-top: ${(props: any) => props.theme && props.theme.content && 
      '1px solid '+ props.theme.content.Borders_hover_colour}
    border-bottom: ${(props: any) => props.theme && props.theme.content && 
        '1px solid '+ props.theme.content.Borders_hover_colour}
    border-right: ${(props: any) => props.theme && props.theme.content && 
      '1px solid '+ props.theme.content.Borders_hover_colour}
    color: white
    font-family: tourismCta;
    &:disabled {
      opacity: 0.5
    }
    &:focus {
      outline: none;
    }
    background: ${(props: any) => props && props.theme && props.theme.content && props.theme.content.Borders_hover_colour}
    &:hover {
      color: ${(props: any) => props.theme && props.theme.content && 
        props.theme.content.cta_font_colour_hover}
    }
    white-space: nowrap;
    @media (max-width: 768px) {
      width: 33%;
    }
  }
`

export const StyledGeoSuggest = styled(GeoSuggest).attrs({
  className: 'addressInput'
})`
  &.addressInput {
    margin-right: 38px;
    width: 95%;
    background: white;
    @media (max-width: 768px) {
      width: 85%;
      margin-right: 51px;
    }
      .geosuggest__input {
        border-bottom: ${(props: any) => props.theme && props.theme.content && 
          '2px solid '+ props.theme.content.Borders_hover_colour}
          &:focus {
            outline: none;
            border-top-color: white;
            border-left-color: white;
            border-right-color: white;
          }
      }
  }

  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 90px;
  width: 100%;
  box-sizing: border-box;
`
export const MainWrapper = styled.div`
  background: -webkit-linear-gradient(${(props: any) => JSON.parse(props.theme.colors).backgroundDark2}, 
    ${(props: any) => JSON.parse(props.theme.colors).backgroundDark3});
  background: linear-gradient(${(props: any) => JSON.parse(props.theme.colors).backgroundDark2}, 
    ${(props: any) => JSON.parse(props.theme.colors).backgroundDark3});
  color: ${(props: any) => JSON.parse(props.theme.colors).bodyHighlght};
  width: 100%;
  min-height: 100%;
  padding: 40px;
  box-sizing: border-box;
`

export const ConditionsMessage = styled<IConditionalMessageProps, 'h3'>('h3')`
    margin: 0 auto;
    width: 100%;
    white-space: nowrap;
    font-weight: 200;
    line-height: 1.2;
    color: ${(props: any) => JSON.parse(props.theme.colors).backgroundMid};
    font-size: 0.8em;
    padding-left: 0;
    text-align: center;
    a {
        color: ${(props: any) => JSON.parse(props.theme.colors).backgroundMid};
    }
    p {
      margin-top: ${(props: any) => props.addMargin ? '3px': '15px'};
      margin-bottom: 3px;
    }
    @media (max-width: 768px) {
      margin-bottom: 0;
  }
`

export const LanguageSelectionText = styled.p`
  background: white;
  text-align: center;
  margin: 0;
  padding-top: 18px;
  font-weight: bold;
`
export const CentreSpan = styled<ICentreProps, 'span'>('span')`
  display: flex; 
  justify-content: center;
  flex-direction: column; 
  background: ${(props: any) => props.theme.content.site_background};
  @media (min-width: 768px) {
    padding-bottom: ${(props: any) => props.addPadding ? '23px': '43px'};
  }
  @media (max-width: 768px) {
    padding-bottom: ${(props: any) => props.addPadding ? '10vh': '14vh'};
  }
`

export const InputForm = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (min-width: 768px) {
    width: 653px;
    margin: 0 auto;
  }
`



// WEBPACK FOOTER //
// ./src/styles/PreArrivalPage.styles.ts